import type { ApiErrorBody } from './api';

/**
 * Stale-write protection. A save of a record several people edit
 * sends `expected_updated_at`, the version it started from. When the record has changed since,
 * the Worker saves nothing and answers 409 `<DOMAIN>_STALE` with who changed it and when; the page
 * keeps the person's draft and shows DataChangedBanner with Reload.
 */

export const TASK_DESCRIPTION_STALE = 'TASK_DESCRIPTION_STALE' as const;
/** T-59: a task's spec, by its own `spec_updated_at`. */
export const TASK_SPEC_STALE = 'TASK_SPEC_STALE' as const;
/** SF-T-111: a project connection (Settings › Secrets). */
export const CONNECTION_STALE = 'CONNECTION_STALE' as const;

/** Who saved the newer version. `name` is null when it was a sync or the person has gone. */
export interface StaleWriteActor {
  user_id: string | null;
  name: string | null;
}

/** The 409 body of a stale save. */
export interface StaleWriteBody extends ApiErrorBody {
  updated_by: StaleWriteActor | null;
  /** When the newer version was saved (ISO). */
  updated_at: string | null;
}

/** True for any `<DOMAIN>_STALE` code. */
export function isStaleWriteCode(code: string | null | undefined): boolean {
  return typeof code === 'string' && code.endsWith('_STALE');
}
